/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tasks_Protocol_CompleteInputs */

const cs_tasks_protocol_complete = /** @type {(inputs: Tasks_Protocol_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Označit jako podepsané`)
};

const en_tasks_protocol_complete = /** @type {(inputs: Tasks_Protocol_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark signed`)
};

/**
* | output |
* | --- |
* | "Mark signed" |
*
* @param {Tasks_Protocol_CompleteInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const tasks_protocol_complete = /** @type {((inputs?: Tasks_Protocol_CompleteInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tasks_Protocol_CompleteInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tasks_protocol_complete(inputs)
	return cs_tasks_protocol_complete(inputs)
});